module.exports = __webpack_public_path__ + "9a1fdd87efeec17ffc1f6fe531565d26.fbx";